import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f6c31c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Painting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Flash" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "PaintingExplore view-default"
}
const _hoisted_5 = { class: "view-default__inner" }
const _hoisted_6 = {
  key: 0,
  class: "PaintingPhoto view-default"
}
const _hoisted_7 = { class: "view-default__inner" }
const _hoisted_8 = {
  key: 1,
  class: "PaintingSnapshot view-default"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "view-default__inner" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIBtnCamera = _resolveComponent("UIBtnCamera")!
  const _component_ui_btn_secondary = _resolveComponent("ui-btn-secondary")!
  const _component_PhotoSettings = _resolveComponent("PhotoSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["PaintingFlash", { 'PaintingFlash--flashing': _ctx.flash }])
    }, _hoisted_3, 2),
    _createVNode(_Transition, {
      onEnter: _ctx.onEnterUI,
      onEnterCancelled: _ctx.onEnterCancelledUI,
      onLeave: _ctx.onLeaveUI,
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.state.matches('painting.explore.default'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_UIBtnCamera, { onClick: _ctx.onEnterPhoto }, null, 8, ["onClick"]),
                _createVNode(_component_ui_btn_secondary, {
                  class: "PaintingExplore__CtaBack",
                  direction: _ctx.UIBtnSecondaryDirection.BACKWARDS,
                  onClick: _ctx.goToMuseum
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.back_to_museum')), 1)
                  ]),
                  _: 1
                }, 8, ["direction", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onEnter", "onEnterCancelled", "onLeave"]),
    (_ctx.state.matches('painting.photo'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_PhotoSettings)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.matches('painting.snapshot'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}